import { render, staticRenderFns } from "./Seminars.vue?vue&type=template&id=e3c39cee&scoped=true&"
import script from "./Seminars.vue?vue&type=script&lang=js&"
export * from "./Seminars.vue?vue&type=script&lang=js&"
import style0 from "./Seminars.vue?vue&type=style&index=0&id=e3c39cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c39cee",
  null
  
)

export default component.exports